export default {
    'name': 'quotation',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M7.49042 21.7537L2.40002 13.6393V10.5145L7.38963 2.40009L11.6232 4.31529L7.94403 12.0769L11.6232 19.8889L7.49042 21.7537ZM17.9232 21.7537L12.8328 13.6393V10.5145L17.8224 2.40009L22.056 4.31529L18.3768 12.0769L22.056 19.8889L17.9232 21.7537Z\' fill=\'#FF4171\'/>'
}
